var exports = {
  "K": "RecipientAddMessage.module__icon___UEdObm",
};

module.exports = exports;
